import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers/api.http';
import { BehaviorSubject } from 'rxjs';
import { XpressUserProfile } from 'app/models';

@Injectable()
export class XpressUserService {

    private initialProfileSubject = new BehaviorSubject<XpressUserProfile>(new XpressUserProfile());
    currentProfile = this.initialProfileSubject.asObservable();

    constructor(
        private apiHttp: ApiHttp) {
    }

    public getXpressUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/GetById', data, messageService);
    }

    public getXpressUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUsers', data, messageService);
    }

    public updateUserBetaFeatures(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/UpdateUserBetaFeatures', data, messageService);
    }

    public saveSuspendByUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/SaveSuspendByUser', data, messageService);
    }

    public updatePersonalInfo(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/UpdateUser', data, messageService);
    }

    public getUserAnalytics(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserAnalytics', data, messageService);
    }

    public getUserAddresses(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserAddresses', data, messageService);
    }

    public getUserTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserTransactions', data, messageService);
    }

    public getUserRefferals(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserRefferals', data, messageService);
    }

    public getUserPromos(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserPromos', data, messageService);
    }

    public getUserShedule(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserShedule', data, messageService);
    }

    public removeUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/RemoveUser', data, messageService);
    }

    public getAuthData(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/GetAuthData', null, messageService);
    }

    public changePassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/ChangePassword', data, messageService);
    }

    public searchUsers(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/SearchUsers', data, messageService);
    }

    public searchUsersByRole(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/SearchUsersByRole', data, messageService);
    }

    public getInfoUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetInfoUser', data, messageService);
    }

    public getUserOrdersHistory(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserOrdersHistory', data, messageService);
    }

    public bannedUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/BannedUser', data, messageService);
    }

    public liftBanUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/LiftBanUser', data, messageService);
    }

    public liftSuspensionUser(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/LiftSuspensionUser', data, messageService);
    }

    public getUsersSuspendedAndBlacklist(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUsersSuspendedAndBlacklist', data, messageService);
    }

    public resetUserPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/ResetXpressUserPassword', data, messageService);
    }

    public resetPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/ResetPassword', data, messageService);
    }

    public getUserProfile(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetUserProfile', data, messageService);
    }

    public updateUserProfile(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/UpdateUserProfile', data, messageService);
    }

    public checkPassword(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/CheckPassword', data, messageService);
    }

    public setSpecialDiscount(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/SetSpecialDiscount', data, messageService);
    }

    updateProfile(newProfile: XpressUserProfile){
        this.initialProfileSubject.next(newProfile);
	}

	public checkPhone(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/XpressUser/CheckPhone', data, messageService);
	}

    public checkEmail(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressUser/CheckEmail', data, messageService);
    }

    public requestSendLogs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/RequestSendLogs', data, messageService);
    }

    public getSendLogRequests(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminXpressUser/GetSendLogRequests', data, messageService);
    }
}
